import { render, staticRenderFns } from "./LeftMenuFooter.vue?vue&type=template&id=93179cfe&scoped=true&"
import script from "./LeftMenuFooter.vue?vue&type=script&lang=js&"
export * from "./LeftMenuFooter.vue?vue&type=script&lang=js&"
import style0 from "./LeftMenuFooter.vue?vue&type=style&index=0&id=93179cfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93179cfe",
  null
  
)

export default component.exports